import { StoreExt } from '@utils/reactExt'
import { observable, action, runInAction } from 'mobx'
import { createRandomCode } from '@src/utils';
import { userStore } from '@src/store';
import { EVENT_TRACING_PAGE, EVENT_TRACING_CLICK } from '@constants/index'

class LoginStore extends StoreExt {
    @observable randomCode: string = createRandomCode()
    @observable captchaUrl: string = this.api.getCaptchaUrl(this.randomCode)
    @observable captchaCustomUrl: string = this.api.getCaptchaCustomUrl(this.randomCode)
    @observable showCustom: boolean
    @observable loginStatus: boolean = false // 登录交互

    // 登录状态
    @action
    setLoginStatus = (val: boolean) => runInAction(() => this.loginStatus = val)

    @action
    refresh = () => {
        const randomCodeUrl = createRandomCode()
        runInAction(() => {
            this.randomCode = randomCodeUrl
            this.captchaUrl = this.api.getCaptchaUrl(randomCodeUrl)
        })
    }

    @action
    refreshCustom = () => {
        const randomCodeUrl = createRandomCode()
        runInAction(() => {
            this.randomCode = randomCodeUrl
            this.captchaCustomUrl = this.api.getCaptchaCustomUrl(randomCodeUrl)
        })
    }

    // 手机登录
    @action
    loginByPhone = async (param = {}) => {
        this.setLoginStatus(true)
        await this.api.loginByPhone(param).catch(e => {
            this.setLoginStatus(false)
            this.refresh()
            this.refreshCustom()
        })
        userStore.sendEventTracing({
            pageCode: EVENT_TRACING_PAGE.LOGIN,
            buttonCode: EVENT_TRACING_CLICK.OP_LOGIN,
            buttonInfo: 'phone' // 登录方式
        })
        await userStore.getUserInfo(false) // 查询用户信息
        this.setLoginStatus(false)
    }

    // 用户登录
    @action
    loginByUser = async (param = {}) => {
        this.setLoginStatus(true)
        await this.api.loginByUser(param).catch(err => {
            this.setLoginStatus(false)
            this.refresh()
            this.refreshCustom()
            if (err.err.code === '4001') {
                runInAction(() => this.showCustom = true)
            }
        })
        userStore.sendEventTracing({
            pageCode: EVENT_TRACING_PAGE.LOGIN,
            buttonCode: EVENT_TRACING_CLICK.OP_LOGIN,
            buttonInfo: 'user' // 登录方式
        })
        await userStore.getUserInfo(false) // 查询用户信息
        this.setLoginStatus(false)
    }

    @action
    getLoginMsgCode = async (param, fn?) => {
        await this.api.getLoginMsgCode(param).catch(e => {
            if (!!fn) {
                fn()
            }
            this.refresh()
        })
        this.$toast.info('获取成功')
    }
}

const loginStore = new LoginStore()
export { loginStore, LoginStore }
